export const html = "<p>Leave your name at the iconic Varem Marem in Gyumri.</p>\n";
export const leadHtml = "<p>Leave your name at the iconic Varem Marem in Gyumri.</p>\n";
export const bodyHtml = "";
export const metaText = "Leave your name at the iconic Varem Marem in Gyumri.";